import type { TranslationMessages } from '../../types';

export const rating: TranslationMessages = {
  title: 'Your Ratings',
  subtitle: 'Customer feedback and ratings for your performance',
  loading: 'Loading ratings...',
  rate_your_experience: 'Rate Your Experience',
  how_was_the_service: 'How was the service?',
  service_quality: 'Service Quality',
  friendliness: 'Friendliness',
  professionalism: 'Professionalism',
  speed: 'Speed',
  knowledge: 'Knowledge',
  overall: 'Overall',
  add_comment: 'Add a comment (optional)',
  comment_placeholder: 'Tell us about your experience...',
  submit_rating: 'Submit Rating',
  rating_submitted: 'Rating Submitted',
  thank_you_for_rating: 'Thank you for rating our service!',
  rating_success: 'Your rating has been submitted successfully.',
  anonymous_rating: 'Submit anonymously',
  rating_required: 'Please provide a rating',
  one_star: 'Poor',
  two_stars: 'Fair',
  three_stars: 'Good',
  four_stars: 'Very Good',
  five_stars: 'Excellent',
  rating_distribution: 'Rating Distribution',
  rating_distribution_desc: 'Breakdown of all your customer ratings',
  average_rating: 'Average Rating',
  total_ratings: 'Total Ratings',
  this_week: 'this week',
  verified: 'Verified',
  verified_percent: '% verified',
  high_ratings: 'High Ratings',
  high_ratings_desc: '4+ star ratings',
  filters_sorting: 'Filters & Sorting',
  filter_by: 'Filter by:',
  all_ratings: 'All Ratings',
  verified_only: 'Verified Only',
  unverified_only: 'Unverified Only',
  high_ratings_filter: 'High Ratings (4+)',
  low_ratings_filter: 'Low Ratings (2-)',
  sort_by: 'Sort by:',
  sort_date: 'Date (Newest)',
  sort_rating: 'Rating (Highest)',
  sort_category: 'Category',
  customer_ratings: 'Customer Ratings',
  customer_ratings_desc: 'Recent customer feedback and ratings',
  verified_by_manager: 'Verified by manager on',
  failed_load: 'Failed to load ratings',
  category_customer_service: 'Customer Service',
  category_speed: 'Speed',
  category_product_knowledge: 'Product Knowledge',
};
